import  { useState } from "react";


const PexelsSearch = () => {
  const [query, setQuery] = useState("");
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_KEY = "Dk2YjB1ATcdQylpcl0lcrLC4VwHxfQaiCXnTVflM5pHSynVjVIFEBa88"; // اینجا کلید Pexels خودت رو بذار

  const handleSearch = async () => {
    if (!query) return;
    setLoading(true);
    try {
      const res = await fetch(
        `https://api.pexels.com/v1/search?query=${encodeURIComponent(
          query
        )}&per_page=10000`,
        {
          headers: {
            Authorization: API_KEY,
          },
        }
      );
      const data = await res.json();
      setPhotos(data.photos);
    } catch (err) {
      console.error(err);
      alert("Error fetching photos");
    }
    setLoading(false);
  };

  return (
    <div className="container my-4">
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search for photos..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button className="btn btn-primary" onClick={handleSearch}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      <div className="row">
        {photos.map((photo) => (
          <div key={photo.id} className="col-6 col-md-3 mb-3">
            <div className="card">
              <img
                src={photo.src.medium}
                alt={photo.photographer}
                className="card-img-top"
              />
              <div className="card-body p-2">
                <p className="card-text small mb-1">{photo.photographer}</p>
                <a
                  href={photo.src.original}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-primary w-100"
                >
                  Select
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PexelsSearch;
